import React from 'react';
import packageJson from '../package.json';
import { config } from './Constants';
global.appVersion = packageJson.version;

// version from response - first param, local version second param
const semverGreaterThan = (versionA, versionB) => {
    const versionsA = versionA.split(/\./g);

    const versionsB = versionB.split(/\./g);
    while (versionsA.length || versionsB.length) {
        const a = Number(versionsA.shift());

        const b = Number(versionsB.shift());
        // eslint-disable-next-line no-continue
        if (a === b) continue;
        // eslint-disable-next-line no-restricted-globals
        return a > b || isNaN(b);
    }
    return false;
};

class CacheBuster extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingNew: true,
            isLatestVersion: false,
            refreshCacheAndReload: () => {
                console.log('Clearing cache and hard reloading...')
                if (caches) {
                    // Service worker cache should be cleared with caches.delete()
                    caches.keys().then(function (names) {
                        for (let name of names) caches.delete(name);
                    });
                }

                // delete browser cache and hard reload
                window.location.reload(true);
            }
        };
    }

    componentDidMount() {

        var URL = "/meta.json";

        if (config.url.EnvType == "PROD" || config.url.EnvType == "DEV") {
            URL = `/meta.json?${new Date().getTime()}`
        }
        else {
            URL = `/EasyDebentures/meta.json?${new Date().getTime()}`;
        } 

        fetch(URL, { cache: 'no-cache' })
            .then((response) => response.json())
            .then((meta) => {
                const latestVersion = meta.version;
                const currentVersion = global.appVersion;

                const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
                if (shouldForceRefresh) {
                    console.log(`We have a new version - ${latestVersion}. Should force refresh`);
                    this.setState({ loadingNew: false, isLatestVersion: false });
                } else {
                    console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`);
                    this.setState({ loadingNew: false, isLatestVersion: true });
                }
            });
    }
    render() {
        const { loadingNew, isLatestVersion, refreshCacheAndReload } = this.state;
        return this.props.children({ loadingNew, isLatestVersion, refreshCacheAndReload });
    }
}

export default CacheBuster;